'use client';
import Footer from '@/app/components/layout/Footer';
import { useFooter } from '@/contexts/footer';

export default function FooterWrapper() {
  const { isFooterVisible } = useFooter();

  if (!isFooterVisible) return null;
  return <Footer />;
}
